// Client de solo lectura de `retail-catalog-business` para «Catálogo de productos».
// Una función por operationId del OpenAPI; las formas de respuesta viven en `catalog.contract.ts`.
import { apiFetch } from '../../client';
import type {
    CatalogInventoryItem,
    CatalogProduct,
    InventoryStorePieces,
    StoreCatalogItem,
} from './catalog.contract';

const BASE_URL = import.meta.env.VITE_API_RETAIL_CATALOG_BASE_URL;

function call<T>(path: string): Promise<T> {
    return apiFetch<T>(path, { baseUrl: BASE_URL });
}

export type {
    CatalogInventoryItem,
    CatalogProduct,
    InventoryStorePieces,
    StoreCatalogItem,
} from './catalog.contract';

/** Filtros de `publicListProducts`. */
export interface ListProductsFilters {
    brand?: string;
    tier?: string;
    capacity?: string;
    color?: string;
    status?: string;
}

/** `publicListProducts` — GET /retailers/{retailerId}/products. */
export function listProducts(
    retailerId: string,
    filters: ListProductsFilters = {},
): Promise<CatalogProduct[]> {
    const qs = new URLSearchParams(
        Object.entries(filters).filter(([, v]) => v != null && v !== '') as [string, string][],
    ).toString();
    return call<CatalogProduct[]>(`/retailers/${retailerId}/products${qs ? `?${qs}` : ''}`);
}

/** `publicGetProduct` — GET /retailers/{retailerId}/products/{sku}. */
export function getProduct(retailerId: string, sku: string): Promise<CatalogProduct> {
    return call<CatalogProduct>(`/retailers/${retailerId}/products/${encodeURIComponent(sku)}`);
}

/** `publicListStoreInventory` — fila por SKU de la tienda, con disponible y precio vigente. */
export function listStoreInventory(
    retailerId: string,
    storeId: string,
): Promise<StoreCatalogItem[]> {
    return call<StoreCatalogItem[]>(`/retailers/${retailerId}/stores/${storeId}/inventory`);
}

/** `publicListInventoryByProduct` — piezas del SKU por tienda; vacío si es por cantidad o kit. */
export function listInventoryByProduct(
    retailerId: string,
    sku: string,
): Promise<InventoryStorePieces[]> {
    return call<InventoryStorePieces[]>(
        `/retailers/${retailerId}/inventory/by-product/${encodeURIComponent(sku)}`,
    );
}

/** `publicGetInventoryItem` — ficha de una pieza por IMEI o serie. */
export function getInventoryItem(
    retailerId: string,
    identifier: string,
): Promise<CatalogInventoryItem> {
    return call<CatalogInventoryItem>(
        `/retailers/${retailerId}/inventory/${encodeURIComponent(identifier)}`,
    );
}
